import { Page } from "@sunrun/sales-experience-shared";
import { useChatAdapter } from "adapters/chat";
import { IFrame } from "components/atoms/IFrame";

type Props = { page: Page };
const ChatIFrame = ({ page }: Props) => {
  const { basePath, ref, src, title } = useChatAdapter(page);

  return <IFrame basePath={basePath} ref={ref} title={title} src={src} />;
};

export { ChatIFrame };
